var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    {
      staticClass: "zw-popup-container",
      attrs: { name: "enterRight", tag: "div" }
    },
    _vm._l(_vm.alerts, function(alert, index) {
      return _c(
        "div",
        {
          key: alert.id,
          staticClass: "ui compact floating zw-popup message",
          class: alert.type,
          style: _vm.findAlign(alert.align)
        },
        [
          !alert.closebutton === false || alert.closebutton === undefined
            ? _c("i", {
                staticClass: "close icon",
                on: {
                  click: function($event) {
                    return _vm.closeAlert(0, index, "click")
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "header",
            domProps: { innerHTML: _vm._s(alert.header) }
          }),
          _vm._v(" "),
          alert.message
            ? _c("p", { domProps: { innerHTML: _vm._s(alert.message) } })
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-653770f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-653770f5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notifications/Alert.vue
// module id = YeQW
// module chunks = 1